export type ClassValue = string | number | null | false | undefined;

export function cx(...args: ClassValue[]): string {
  return args.filter(Boolean).join(" ");
}
